/**
 * Sessão de itinerário do fluxo "Criar rota".
 *
 * Cada pedido novo tem uma assinatura própria (destino canónico + duração +
 * interesses + modo). Quando a assinatura muda, o resultado anterior é
 * descartado por inteiro: nada de append/merge, nada de caches genéricas de
 * "itinerary" nem chaves só por índice.
 */

export type ItinerarySessionInput = {
  provider?: string;
  providerPlaceId?: string;
  countryCode?: string;
  city?: string;
  lat?: number;
  lng?: number;
  durationHours?: number;
  interests?: readonly string[];
  mode?: string;
};

/** Assinatura estável e comparável de um pedido de itinerário. */
export function itinerarySessionSignature(input: ItinerarySessionInput): string {
  return [
    input.provider ?? "",
    input.providerPlaceId ?? "",
    (input.countryCode ?? "").toUpperCase(),
    (input.city ?? "").trim().toLowerCase(),
    Number.isFinite(input.lat) ? (input.lat as number).toFixed(4) : "",
    Number.isFinite(input.lng) ? (input.lng as number).toFixed(4) : "",
    String(input.durationHours ?? ""),
    [...(input.interests ?? [])].slice().sort().join(","),
    input.mode ?? "",
  ].join("|");
}

/** true quando o pedido novo tem de abrir uma sessão limpa. */
export function requiresNewItinerarySession(
  currentSignature: string,
  next: ItinerarySessionInput,
): boolean {
  return itinerarySessionSignature(next) !== currentSignature;
}

/**
 * Chave de cache de uma paragem de refeição/alojamento, sempre no âmbito da
 * sessão atual — "lunch:2" de Sintra nunca colide com "lunch:2" de Londres.
 */
export function scopedBreakKey(scope: string, meal: string, afterStopIdx: number): string {
  return `${scope}|${meal}:${afterStopIdx}`;
}
